export const NotificationType=[
    {id:1,label:'Unpaid'},
    {id:2,label:'Paid'},
    {id:3,label:'Completed'},
    {id:4,label:'Referred'},
]